import { render } from "./DialogNotExitTrain.vue?vue&type=template&id=00d422a4"
import script from "./DialogNotExitTrain.vue?vue&type=script&lang=js"
export * from "./DialogNotExitTrain.vue?vue&type=script&lang=js"
script.render = render

export default script